import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HttpCacheService {
  private cache: { [key: string]: { data: any, timestamp: number, cacheTime: number } } = {};
  private defaultCacheTime: number = 3 * 60 * 1000; // デフォルトのキャッシュ有効期限（ミリ秒）
  private cleanupInterval: any;

  constructor() {
    // 定期的にキャッシュをクリア
    this.cleanupInterval = setInterval(() => this.cleanupExpiredCache(), this.defaultCacheTime);
  }

  getCachedData(url: string): any {
    const cachedResponse = this.cache[url];
    if (cachedResponse) {
      const isExpired = Date.now() - cachedResponse.timestamp >= cachedResponse.cacheTime;
      if (isExpired) {
        // キャッシュが期限切れの場合は削除
        delete this.cache[url];
        return null;
      }
      return cachedResponse.data;
    }
    return null;
  }

  setCachedData(url: string, data: any, cacheTime: number = this.defaultCacheTime): void {
    this.cache[url] = {
      data: data,
      timestamp: Date.now(),
      cacheTime: cacheTime
    };
  }

  clearCache(url?: string): void {
    if (url && this.cache[url]) {
      delete this.cache[url];
    } else {
      this.cache = {};
    }
  }

  // 有効期限切れのキャッシュを削除するメソッド
  private cleanupExpiredCache(): void {
    const now = Date.now();
    for (const url in this.cache) {
      if (now - this.cache[url].timestamp >= this.cache[url].cacheTime) {
        delete this.cache[url];
      }
    }
  }
  ngOnDestroy(): void {
    // サービスが破棄されるときにインターバルをクリア
    if (this.cleanupInterval) {
      clearInterval(this.cleanupInterval);
    }
  }

}
